import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import SubHeader from './SubHeader';

const VideoHeader = ({
  title,
  createdAt,
  readTime,
  wordCount,
  location,
  community,
  postTitlePadding,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const useStyles = makeStyles()(() => ({
    heading: {
      padding: isMobile ? '5px 20px 5px 20px' : '10px 0 5px 0',
    },
  }));

  const { classes } = useStyles();

  return (
    <>
      <div
        className={
          postTitlePadding ? '-tw-mt-24 xl:-tw-mt-28 tw-mb-8' : classes.heading
        }
      >
        <Typography
          variant="h4"
          component="h1"
          className="pb-0"
          color="textPrimary"
        >
          {title}
        </Typography>
        <SubHeader
          createdAt={createdAt ? String(createdAt) : undefined}
          readTime={readTime}
          wordCount={wordCount}
          location={location}
          community={community}
        />
      </div>
    </>
  );
};

export default VideoHeader;
